import { render, staticRenderFns } from "./AssignDocumentModal.vue?vue&type=template&id=f56050e2&scoped=true"
import script from "./AssignDocumentModal.vue?vue&type=script&lang=js"
export * from "./AssignDocumentModal.vue?vue&type=script&lang=js"
import style0 from "./AssignDocumentModal.vue?vue&type=style&index=0&id=f56050e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56050e2",
  null
  
)

export default component.exports